module.exports = __webpack_public_path__ + "static/media/imgEventDefaul.217c3440.jpg";